// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../../styles/components/analytics/KeyGoalItem.scss';


class KeyGoalItem extends Component {
  constructor(props) {
    super(props);
  }

  renderIcon(enabled) {
    if (enabled) {
      return (
        <svg width='35' height='35' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
          <g id='Symbols' fill='none' fillRule='evenodd'>
            <g id='icon_checkmark' fill='#65A637'>
              <path d='M10,0 C4.47714286,0 0,4.47714286 0,10 C0,15.5228571 4.47714286,20 10,20 C15.5228571,20 20,15.5228571 20,10 C20,4.47714286 15.5228571,0 10,0 Z M16.7224762,6.70609524 L8.13466667,15.2939048 C8.06057143,15.368 7.93942857,15.368 7.86533333,15.2939048 L3.5632381,10.9918095 C3.48914286,10.9177143 3.48914286,10.7965714 3.5632381,10.7224762 L5.29390476,8.99180952 C5.368,8.91771429 5.48914286,8.91771429 5.5632381,8.99180952 L7.86533333,11.2939048 C7.93942857,11.368 8.06057143,11.368 8.13466667,11.2939048 L14.7224762,4.70609524 C14.7965714,4.632 14.9177143,4.632 14.9918095,4.70609524 L16.7224762,6.4367619 C16.7965714,6.51085714 16.7965714,6.632 16.7224762,6.70609524 Z'
                id='Checkmark' />
            </g>
          </g>
        </svg>
      );
    } else {
      return (
        <svg width='35' height='35' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
          <g id='15_Analytics_Sec.Rec.S.I.Dashboards' fill='none' fillRule='evenodd' transform='translate(-596 -734)'>
            <g id='TEXT-BLOCKS' transform='translate(202 500)' stroke='#C5081F'>
              <g id='text-block' transform='translate(394 147)'>
                <g strokeWidth='3' transform='translate(0 87)' id='Disabled-icon'>
                  <circle id='Oval' cx='10' cy='10' r='8.5' />
                  <path d='M14.5,4.5 L5.5,15.5' id='Line' strokeLinecap='square' />
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    }
  }

  render() {
    const { goal, active } = this.props;
    const classNames = classnames({
      'analytics__key-goal-item-pptx': true,
      'analytics__key-goal-item--positive': active === true && goal.answer === 1,
      'analytics__key-goal-item--negative': active === false || active === true && goal.answer !== 1
    });

    return (
      <div className={classNames}>
        <div className='row'>
          <div className='col-md-1 analytics__key-goal-item__icon-container-pptx'>
            {this.renderIcon(active === true && goal.answer === 1)}
          </div>
          <div className='col-md-11 analytics__key-goal-item__title-pptx'>
            {goal.title}
          </div>
        </div>
      </div>
    );
  }
}

KeyGoalItem.propTypes = {
  goal: PropTypes.object.isRequired,
  active: PropTypes.bool
};

export default KeyGoalItem;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/KeyGoalItem.js